import { useEffect } from 'react'


const GoalBase = ({ children, classNameApplied }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            {/* <header className={`Header__Secondary container ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                {classNameApplied && classNameApplied !== '' ? (
                    <button type='button' className='Header__Secondary__Buttons Btn__Adsl--WhiteOutlineTransparent' onClick={Logout}>
                        <i className="bi bi-box-arrow-right"></i>
                    </button>
                ) : (
                    <button type='button' className='Header__Secondary__Buttons Btn__Adsl--RedOutline' onClick={Logout}>
                        <i className="bi bi-box-arrow-right"></i>
                    </button>
                )}
            </header> */}

            <main className={`container Dashboard Container-FullHeight ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                {/* <div className="ReturnButton">
                    {classNameApplied && classNameApplied !== '' ? (
                        <button className='ReturnButton__Button__White' onClick={() => ActionToExecute()}>
                            <i className="bi bi-arrow-90deg-left fs-5"></i>
                        </button>
                    ) : (
                        <button className='ReturnButton__Button' onClick={() => ActionToExecute()}>
                            <i className="bi bi-arrow-90deg-left fs-5"></i>
                        </button>
                    )}
                </div> */}

                <div className="row mt-3">
                    {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" /> */}
                    <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />
                    {/* <img src="/img/games/runtogoal/snackshow/snackshow-logotipo-150x150.png" style={{ width: '160px', margin: 'auto' }} alt="Logo" /> */}

                    <div className="mt-2">
                        {children}
                    </div>
                </div>
            </main>

            <footer className='container'>
                <p className='text-center FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</p>
            </footer>
        </>
    )
}

export { GoalBase };